if (!customElements.get('quick-add-modal')) {
  customElements.define(
    'quick-add-modal',
    class QuickAddModal extends ModalDialog {
      constructor() {
        super();
        this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');

        this.addEventListener('product-info:loaded', ({ target }) => {
          target.addPreProcessCallback(this.preprocessHTML.bind(this));
        });
      }

      hide(preventFocus = false) {
        const cartNotification = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        if (cartNotification) cartNotification.setActiveElement(this.openedBy);
        this.modalContent.innerHTML = '';

        if (preventFocus) this.openedBy = null;
        super.hide();
      }

      show(opener) {
        opener.setAttribute('aria-disabled', true);
        opener.classList.add('loading');
        opener.querySelector('.loading__spinner').classList.remove('hidden');

        fetch(opener.getAttribute('data-product-url'))
          .then((response) => response.text())
          .then((responseText) => {
            const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
            const productElement = responseHTML.querySelector('product-info');

            this.preprocessHTML(productElement);
            HTMLUpdateUtility.setInnerHTML(this.modalContent, productElement.outerHTML);

            if (window.Shopify && Shopify.PaymentButton) {
              Shopify.PaymentButton.init();
            }
            if (window.ProductModel) window.ProductModel.loadShopifyXR();

            super.show(opener);
          })
          .finally(() => {
            opener.removeAttribute('aria-disabled');
            opener.classList.remove('loading');
            opener.querySelector('.loading__spinner').classList.add('hidden');

            //custom add to cart 
              document.querySelectorAll('.selling-plan-group ul li').forEach((item) => {
                  item.addEventListener('click', () => {
                      const parent = item.closest('.product_form_btn');
                      parent.querySelectorAll('.selling-plan-group ul li').forEach((li) =>
                          li.classList.remove('active')
                      );
                      item.classList.add('active');
                  });
              });
          
              document.querySelectorAll('.btn_adop_product span').forEach((item) => {
                  item.addEventListener('click', () => {
                      const parent = item.closest('.product_form_btn');
                      const variantId = parent.querySelector('.selling-plan-group ul li.active').getAttribute('data-variantid');
                      const variantName = parent.querySelector('.selling-plan-group ul li.active').getAttribute('data-title');
                      if (variantName == 'One Time Contribution') {
                          AddToCart(variantId, 1, '');
                      } else {
                          const sellingPlan_ID = parent.querySelector('.selling-plan-group-id ul li[data-name="' + variantName + '"]').getAttribute('data-id');
                          AddToCart(variantId, 1, sellingPlan_ID);
                      }
                  });
              });

              const donateBtns = document.querySelectorAll('.donateBtn');
              if (donateBtns) {
                donateBtns.forEach(function(btn) {
                  btn.addEventListener('click', function () {
                    const optionDonate = this.closest('.custom_option_donate');
                    if(optionDonate){
                      const donateAmmount = optionDonate.querySelector('input').value;
                      const number = Number(donateAmmount);
                      if (donateAmmount.trim() === "") {
                          alert('Please enter an amount');
                      } else if (!isNaN(number)) {
                          document.querySelector('.pre_loader').style.display = 'block';
                          const ProductTitle = document.querySelector('.product__title .h1').innerText.trim();
                          const formData = new FormData();
                          formData.append('donateAmmount', number);
                          formData.append('Title', ProductTitle);
                          fetch('https://dev.shopifyexperthelp.com/app/Orrefors/create_variant.php', {
                              method: 'POST',
                              body: formData,
                          }).then(response => response.json())
                            .then(data => {
                              addToCart(data);
                            })
                      }
                    }
                  });
                });
              }
                
              function addToCart(cartdata) {
                console.log(cartdata);
                const variantId = cartdata.varaintId;
                const sellingPlanId = cartdata.sellingplnId;
                
                if (variantId && sellingPlanId) {
                  const lineItem = {
                    id: variantId,
                    quantity: 1,
                    selling_plan: sellingPlanId
                  };
              
                  fetch('/cart/add.js', {
                    method: 'POST',
                    headers: {
                      'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(lineItem)
                  })
                  .then(response => response.json())
                  .then(data => {
                    window.location.href = '/checkout';
                  })
                } else {
                  console.log('erroer');
                  //location.reload();
                }
              }

            function AddToCart(variantId, quantity = 1, sellingPlanId = null) {
                const randomID = Math.floor(Math.random() * 1e6);
                const data = {
                    id: variantId,
                    quantity: quantity,
                    properties: {
                        "Support Id": randomID
                    }
                };
        
                if (sellingPlanId) {
                    data.selling_plan = sellingPlanId;
                }
        
                fetch('/cart/add.js', {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        body: JSON.stringify(data)
                    })
                    .then(response => {
                        if (!response.ok) {
                            throw new Error('Network response was not OK');
                        }
                        return response.json();
                    })
                    .then(data => {
                        window.location.href = '/cart';
                    })
            }
                    
          });
      }

      preprocessHTML(productElement) {
        productElement.classList.forEach((classApplied) => {
          if (classApplied.startsWith('color-') || classApplied === 'gradient')
            this.modalContent.classList.add(classApplied);
        });
        this.preventDuplicatedIDs(productElement);
        this.removeDOMElements(productElement);
        this.removeGalleryListSemantic(productElement);
        this.updateImageSizes(productElement);
        this.preventVariantURLSwitching(productElement);
      }

      preventVariantURLSwitching(productElement) {
        productElement.setAttribute('data-update-url', 'false');
      }

      removeDOMElements(productElement) {
        const pickupAvailability = productElement.querySelector('pickup-availability');
        if (pickupAvailability) pickupAvailability.remove();

        const productModal = productElement.querySelector('product-modal');
        if (productModal) productModal.remove();

        const modalDialog = productElement.querySelectorAll('modal-dialog');
        if (modalDialog) modalDialog.forEach((modal) => modal.remove());
      }

      preventDuplicatedIDs(productElement) {
        const sectionId = productElement.dataset.section;

        const oldId = sectionId;
        const newId = `quickadd-${sectionId}`;
        productElement.innerHTML = productElement.innerHTML.replaceAll(oldId, newId);
        Array.from(productElement.attributes).forEach((attribute) => {
          if (attribute.value.includes(oldId)) {
            productElement.setAttribute(attribute.name, attribute.value.replace(oldId, newId));
          }
        });

        productElement.dataset.originalSection = sectionId;
      }

      removeGalleryListSemantic(productElement) {
        const galleryList = productElement.querySelector('[id^="Slider-Gallery"]');
        if (!galleryList) return;

        galleryList.setAttribute('role', 'presentation');
        galleryList.querySelectorAll('[id^="Slide-"]').forEach((li) => li.setAttribute('role', 'presentation'));
      }

      updateImageSizes(productElement) {
        const product = productElement.querySelector('.product');
        const desktopColumns = product?.classList.contains('product--columns');
        if (!desktopColumns) return;

        const mediaImages = product.querySelectorAll('.product__media img');
        if (!mediaImages.length) return;

        let mediaImageSizes =
          '(min-width: 1000px) 715px, (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)';

        if (product.classList.contains('product--medium')) {
          mediaImageSizes = mediaImageSizes.replace('715px', '605px');
        } else if (product.classList.contains('product--small')) {
          mediaImageSizes = mediaImageSizes.replace('715px', '495px');
        }

        mediaImages.forEach((img) => img.setAttribute('sizes', mediaImageSizes));
      }
    }
  );
}
